export const create = {
  createSuccessfully: 'Create new employee successfully!',
}
